// Module
var code = "<react-component name=\"MetricsReport\"></react-component>\n";
// Exports
module.exports = code;